import React from "react";
import Navbar from "../components/comman/Navbar";
import BreakingNews from "../components/core/HomePage/BreakingNews";
import News from "../components/core/HomePage/News";
import Footer from "../components/comman/Footer";
import Category from "../components/core/HomePage/Category";
import Tab from "../components/core/HomePage/Tab";
import AddSlideBar from "../components/comman/AddSlideBar";

import VIdeos from "../components/home/VIdeos";
import ButtomAdd from "../components/comman/ButtomAdd";
import LatestNews from "../components/home/LatestNews";
import Seo from "../components/comman/Seo";

const Home = () => {
  return (
    <div>
      <Seo />
      <Navbar />

      <div className="mt-40">
        <AddSlideBar />
        <br />
        <BreakingNews />
        <LatestNews />
        <News />
        <br />
        <VIdeos />
        <Category />
        <ButtomAdd />
        <Tab />
      </div>
      <br />
      <br />
      <Footer />
    </div>
  );
};

export default Home;
